const SEND_DELAY_MS = 1500;
const RESET_DELAY_MS = 5000;
const SUCCESS_BG = 'linear-gradient(135deg, #00aa6c, #007750)';

/**
 * Wires the inquiry form's submit handler. Simulates an async send,
 * shows confirmation, and restores the original button after a short delay.
 */
export function initContactForm(formSelector = '.contact-form') {
  const form = document.querySelector(formSelector);
  if (!form) return;

  const button = form.querySelector('.form-submit');
  if (!button) return;

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (button.disabled) return;
    runSubmissionUx(button);
  });
}

function runSubmissionUx(button) {
  const originalLabel = button.textContent;
  button.textContent = 'Sending…';
  button.disabled = true;

  setTimeout(() => {
    button.textContent = '✓ Message Sent — We\'ll be in touch!';
    button.style.background = SUCCESS_BG;

    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
      button.style.background = '';
    }, RESET_DELAY_MS);
  }, SEND_DELAY_MS);
}
